<script setup lang="ts">
import SpeakerIcon from '../SVG/SpeakerIcon.vue';
import ButtonReflectionIcon from '../../assets/icons/button-reflection.svg'
import { computed, onBeforeUnmount, ref } from 'vue';
import { audioManager } from '../../utils/audioManager';
import { ArrowPathIcon } from '@heroicons/vue/16/solid';

const { src, label = '', audioKey = 'audio' } = defineProps<{ src: string, label?: string, audioKey?: string }>()

const isLoading = ref<boolean>(false)
const isPlaying = ref<boolean>(false)

const icon = computed(() => {
    if (isLoading.value) return ArrowPathIcon;
    return SpeakerIcon
})

const handleLoading = () => {
    isLoading.value = true
}

const handlePlaying = () => {
    isLoading.value = false
    isPlaying.value = true
}

const handleStop = () => {
    isLoading.value = false
    isPlaying.value = false
}

function playAudio() {
    audioManager.play(src, audioKey, {
        restart: true,
        priority: 1,
        onloadstart: handleLoading,
        onplaying: handlePlaying,
        onpause: handleStop,
        onended: handleStop,
        onerror: handleStop
    })
}

onBeforeUnmount(() => {
    audioManager.stop(audioKey)
})
</script>

<template>
    <div class="audio-player flex" :class="{ 'animate-pulse': isPlaying }" @click="playAudio">
        <slot :icon="icon" :isLoading="isLoading">
            <div
                class="flex items-center justify-center gap-2 shrink-0 bg-orange-500 hover:bg-orange-600 focus:bg-orange-600 transition-all cursor-pointer py-2 px-4 rounded-3xl relative shadow-[0px_-2px_0_0_#00000033_inset,0px_2px_0_0_#FFFFFF4D_inset]">
                <ButtonReflectionIcon class="absolute size-3 top-1 left-2 pointer-events-none" />
                <span v-if="label" class="text-white whitespace-pre">{{ label }}</span>
                <component :is="icon" class="size-5 fill-white pointer-events-none" :class="{ 'animate-spin': isLoading }" />
            </div>
        </slot>
    </div>
</template>